// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3HUEE","addWidgetButton":"Header_addWidgetButton__k1pIF","dashboardTabs":"Header_dashboardTabs__3-eGu","active":"Header_active__X0n6-"};